import { render, staticRenderFns } from "./VueUpload.vue?vue&type=template&id=29dcf058&scoped=true&"
import script from "./VueUpload.vue?vue&type=script&lang=ts&"
export * from "./VueUpload.vue?vue&type=script&lang=ts&"
import style0 from "./VueUpload.vue?vue&type=style&index=0&id=29dcf058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dcf058",
  null
  
)

export default component.exports